import { Expose, Type } from 'class-transformer'
import { LocationOn } from '@material-ui/icons'

import { Base } from './Base'
import { Facility } from './Facility'

export class Place extends Base {
  static type = 'place'
  static typeDisplay = 'Place'
  static icon = LocationOn

  type = Place.type
  typeDisplay = Place.typeDisplay
  icon = Place.icon

  @Expose({ name: 'xid' })
  guid: string = ''

  name: string = ''

  @Expose({ name: 'can_delete' })
  canDelete?: boolean

  @Type(() => Facility)
  facility?: Facility

  @Expose({ name: 'short_path' })
  shortPath: string = ''

  get parent() {
    if (this.parents && this.parents.length) {
      return this.parents[this.parents.length - 1]
    }
    return null
  }

  @Expose({ name: 'parent_places' })
  @Type(() => Place)
  parents?: Place[]

  get path() {
    const items = []
    if (this.facility) {
      items.push(this.facility.name)
    }
    const placePath = this.parents?.map((parent) => parent.name).join(' > ')
    if (placePath) {
      items.push(placePath)
    }
    items.push(this.name)
    return items.join(' > ')
  }

  get objPath() {
    const items = []
    if (this.facility) {
      items.push(this.facility)
    }
    const placePath = this.parents?.map((parent) => parent)
    if (placePath && placePath.length) {
      items.push(...placePath)
    }
    items.push(this)
    return items
  }
}
